import * as React from "react";
import ContentCard from "../content-card/content-card";
import { AskAboutQuery_SourceData } from "../../../../graphql-types";
import SourceLink from "../source-link/source-link";
import CardContent from "../content-card/card-content";
import { EventCategory } from "../../../utils/analytics";
import styles from "./video-answer.styles";
import AnswerFlag from "./answer-flag";

interface VideoAnswerProps {
  isFeatured?: boolean;
  intentName: string;
  answerIndex: number;
  title: string;
  content?: string[];
  youtubeId: string;
  sources?: AskAboutQuery_SourceData[] | null;
}

const VideoAnswer: React.FC<VideoAnswerProps> = ({
  isFeatured,
  intentName,
  answerIndex,
  title,
  youtubeId,
  content,
  sources = [],
}) => {
  return (
    <ContentCard featureBadge={isFeatured ? "WATCH" : undefined}>
      <CardContent isFullWidthOnMobile={true} isNarrow={true}>
        <div css={styles.videoContainer}>
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${youtubeId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            // @ts-ignore Youtube attribute
            enablejsapi={1}
          ></iframe>
        </div>
      </CardContent>

      <CardContent isNarrow={true}>
        <h2 css={styles.heading}>{title}</h2>

        {!!content && (
          <div
            css={styles.content}
            className="content"
            dangerouslySetInnerHTML={{
              __html: content.join(""),
            }}
          />
        )}

        {sources && (
          <SourceLink
            sources={sources}
            eventCategory={EventCategory.Section_VideoAnswer}
          />
        )}
      </CardContent>

      <AnswerFlag
        intentName={intentName}
        answerIndex={answerIndex}
        answerType="video"
      />
    </ContentCard>
  );
};

export default VideoAnswer;
